var notices = [

    {
        "body":"List of Accepted Papers",
        "url": "https://docs.google.com/spreadsheets/d/1-inbeJuqel5bbkDfmvSmMRStinqpQ_fB_s6p6kH93sw/edit?usp=sharing"
    },
    { 
        "body": "Conference Schedule",
        "url": "https://drive.google.com/file/d/1tE5wqh5PLb30hNE7X5osP7TbjqcEKl9v/view?usp=sharing"
    },
    {
        "body":"Conference Platform",
        "url":"https://isea-events.in/"
    }

    
]

export default notices